module.exports = __webpack_public_path__ + "static/media/raven_funny_01.03788443.svg";